export const locale = {
    lang: 'en',
    data: {
        EMAILS_LIST: {
            TITLES: {
                CC_ED: 'CC\'ed',
                LOGIN_EMAIL: 'LOGIN EMAIL',
                EMPTY: 'You have not saved an email address.',
            }
        }
    }
};